module.exports = __webpack_public_path__ + "img/arrows-1-2.ddf01fa3.svg";